import { useEffect, useState } from 'react';

import InstitutionAvailability from './InstitutionAvailability';

import { getPostalcodeData } from '../../../actions/mainForm';

import {
    Grid2, TextField, FormControl,
    InputLabel, Select, MenuItem, Typography,
    Box, FormGroup, FormControlLabel, Switch
} from '@mui/material';
import AccessTimeIcon from '@mui/icons-material/AccessTime';

const MedicoInstitucion = ({
    institution, setInstitution, institution_types, show_address
}) => {
    const {
        idTipoHospital, address,
        street, num_ext, num_int, postalCode, colony, city, state,
        check, schedules: { sunday, monday, tuesday, wednesday, thursday, friday, saturday }
    } = institution;

    // información recuperada con el código postal
    // colonias disponibles para campo de envío
    const [colonies, setColonies] = useState([]);
    
    useEffect(() => {
        if (postalCode.length === 5)
            getPostalcode();
        else {
            if (colonies.length > 0) // limpia colonias disponibles
                setColonies([]);
        }
    }, [postalCode]);

    const getPostalcode = async () => {
        const resp = await getPostalcodeData(postalCode);
        if (resp.status) {
            const { resp: { municipio, estado, asentamiento } } = resp;
            setInstitution(e => ({
                ...e,
                colony: '',
                city: municipio,
                state: estado
            }));
            setColonies(asentamiento);
        } else // snackbar para mensaje (No se encontró código postal)
            // limpia colonias disponibles
            setColonies([]);
    };

    const handleSwitchChange = (name, checked) => {
        setInstitution(e => ({ ...e, [name]: checked }));
    };

    const handleInputChange = (name, value) => {
        setInstitution(e => ({ ...e, [name]: value }));
    };

    return (
        <Grid2 container spacing={4}>
            {
                show_address && 
                    <Grid2 size={{ xs: 12 }}>
                        <Typography variant="body1" gutterBottom sx={{ display: 'block' }}>
                            { `Dirección registrada: ${address}` }
                        </Typography>
                    </Grid2>
            }

            <Grid2 size={{ xl: 6, lg: 6, md: 12, sm: 12, xs: 12 }}>
                <FormControl fullWidth>
                    <InputLabel id="idTipoHospital">Tipo de institución</InputLabel>
                    <Select
                        labelId="idTipoHospital"
                        label="Tipo de institución"
                        name='idTipoHospital'
                        value={idTipoHospital || ""}
                        onChange={
                            ({ target: { name, value } }) => handleInputChange(name, value)
                        }
                    >
                        {
                            institution_types.map(({ idTipoHospital, tipoHospital }) =>
                                <MenuItem key={idTipoHospital}
                                    value={idTipoHospital}>
                                    { tipoHospital }
                                </MenuItem>
                            )
                        }
                    </Select>
                </FormControl>
            </Grid2>

            <Grid2 size={{ xl: 6, lg: 6, md: 12, sm: 12, xs: 12 }}>
                <TextField label='Calle' variant='outlined' fullWidth name='street' value={street || ""}
                    onChange={
                        ({ target: { name, value } }) => handleInputChange(name, value)
                    }
                />
            </Grid2>

            <Grid2 size={{ xl: 6, lg: 6, md: 6, sm: 6, xs: 12 }}>
                <TextField label='Número exterior' variant='outlined' fullWidth name='num_ext' value={num_ext || ""}
                    onChange={
                        ({ target: { name, value } }) => handleInputChange(name, value)
                    }
                />
            </Grid2>

            <Grid2 size={{ xl: 6, lg: 6, md: 6, sm: 6, xs: 12 }}>
                <TextField label='Número interior' variant='outlined' fullWidth name='num_int' value={num_int || ""}
                    onChange={
                        ({ target: { name, value } }) => handleInputChange(name, value)
                    }
                />
            </Grid2>

            <Grid2 size={{ xl: 6, lg: 6, md: 6, sm: 12, xs: 12 }}>
                <TextField label='Código postal' variant='outlined' fullWidth name='postalCode' value={postalCode || ""}
                    onChange={
                        ({ target: { name, value } }) => handleInputChange(name, value)
                    }
                    slotProps={{ htmlInput: { maxLength: 5 } }}
                />
            </Grid2>

            <Grid2 size={{ xl: 6, lg: 6, md: 6, sm: 12, xs: 12 }}>
                {
                    (colonies && colonies.length > 0) ?
                        <FormControl fullWidth>
                            <InputLabel>Colonia</InputLabel>
                            <Select
                                name="colony"
                                value={colony || ""}
                                label="Colonia"
                                onChange={
                                    ({ target: { name, value } }) => handleInputChange(name, value)
                                }
                                variant="standard"
                            >
                                {
                                    colonies.map(({ nombre }) =>
                                        <MenuItem key={nombre}
                                            value={nombre}>{nombre}
                                        </MenuItem>
                                    )
                                }
                            </Select>
                        </FormControl>
                    :
                        <TextField label='Colonia'
                            variant='outlined'
                            fullWidth
                        
                            name='colony'
                            value={colony || ""}
                            onChange={
                                ({ target: { name, value } }) => handleInputChange(name, value)
                            }
                            slotProps={{ htmlInput: { maxLength: 60 } }}
                        />
                }
            </Grid2>

            <Grid2 size={{ xl: 6, lg: 6, md: 6, sm: 12, xs: 12 }}>
                <TextField label='Ciudad' variant='outlined' fullWidth name='city' value={city || ""}
                    onChange={
                        ({ target: { name, value } }) => handleInputChange(name, value)
                    }
                    disabled
                />
                {
                    postalCode.length === 5
                        ?
                        null
                        :
                        <Typography variant='body2' sx={{ color: '#ec7063' }}>*Introduce el código postal para completar el campo</Typography>
                }
            </Grid2>

            <Grid2 size={{ xl: 6, lg: 6, md: 6, sm: 12, xs: 12 }}>
                <TextField label='Estado' variant='outlined' fullWidth name='state' value={state || ""}
                    onChange={
                        ({ target: { name, value } }) => handleInputChange(name, value)
                    }
                    disabled
                />
                {
                    postalCode.length === 5
                        ?
                        null
                        :
                        <Typography variant='body2' sx={{ color: '#ec7063' }}>*Introduce el código postal para completar el campo</Typography>
                }
            </Grid2>

            <Grid2 size={{ xl: 12, lg: 12, md: 12, sm: 12, xs: 12 }}>
                <FormGroup>
                    <FormControlLabel
                        control={
                            <Switch checked={check || ""}
                                name='check'
                                onChange={
                                    ({ target: { name, checked } }) => handleSwitchChange(name, checked)
                                }
                            />
                        }
                        label='Acepta visita médica'
                    />
                </FormGroup>
            </Grid2>

            <Grid2 size={{ xl: 12, lg: 12, md: 12, sm: 12, xs: 12 }}>
                {
                    check === true &&
                        <>
                            <Box sx={{ display: 'flex', justifyContent: 'flex-start', gap: '16px', mb: 3 }}>
                                <Box sx={{ mt: .5 }}>
                                    <AccessTimeIcon />
                                </Box>
                                <Box sx={{ my: 'auto' }}>
                                    <Typography variant='h6'>Disponibilidad de visita</Typography>
                                    <Typography variant='body1'>
                                        Establece cuándo suele estar disponible para tener horarios de visita.
                                    </Typography>
                                </Box>
                            </Box>

                            <Grid2 container spacing={4}>

                                <InstitutionAvailability
                                    day={sunday}
                                    day_of_week={'sunday'}
                                    text={'Dom'}
                                    setInstitution={setInstitution}
                                />
                                
                                <InstitutionAvailability
                                    day={monday}
                                    day_of_week={'monday'}
                                    text={'Lun'}
                                    setInstitution={setInstitution}
                                />
                                
                                <InstitutionAvailability
                                    day={tuesday}
                                    day_of_week={'tuesday'}
                                    text={'Mar'}
                                    setInstitution={setInstitution}
                                />
                                
                                <InstitutionAvailability
                                    day={wednesday}
                                    day_of_week={'wednesday'}
                                    text={'Mie'}
                                    setInstitution={setInstitution}
                                />
                                
                                <InstitutionAvailability
                                    day={thursday}
                                    day_of_week={'thursday'}
                                    text={'Jue'}
                                    setInstitution={setInstitution}
                                />
                                
                                <InstitutionAvailability
                                    day={friday}
                                    day_of_week={'friday'}
                                    text={'Vie'}
                                    setInstitution={setInstitution}
                                />
                                
                                <InstitutionAvailability
                                    day={saturday}
                                    day_of_week={'saturday'}
                                    text={'Sáb'}
                                    setInstitution={setInstitution}
                                />
                            </Grid2>
                        </>
                }
            </Grid2>
        </Grid2>
    );
};

export default MedicoInstitucion;